import React, { useState } from "react";
import TagInput from "../../components/form/TagInput";
import { useGetFiltersQuery, usePatchFilterMutation } from "../../store/api/filterApi";

const EmailRules = () => {
  const {
    data: fetchFilter,
    isLoading: filterDataLoading,
    isError: filterDataError,
  } = useGetFiltersQuery();

  // Merging data only if fetched successfully
  const mergedData = fetchFilter?.data?.data

  const [patchFilter] = usePatchFilterMutation();
  const [emailTags, setEmailTags] = useState([]);
  const [bodyTags, setBodyTags] = useState([]);
  const [subjectTag, setSubjectTag] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await patchFilter({
        subject: subjectTag,
        emails: emailTags,
        body: bodyTags,
        type: "email-filter",
      }).unwrap();

      alert("Filter added successfully!");
      // Reset fields after success
      setSubjectTag([]);
      setEmailTags([]);
      setBodyTags([]);
    } catch (error) {
      console.error("Error adding filter:", error);
      alert("Failed to add filter. Please try again.");
    }
  };
 
  return (
    <div className="container-fluid">
      <div className="header mb-3">
        <p className="h3">
          Set Email Rules{" "}
          <span className="text-danger text-xs">(All values were excluded)</span>
        </p>
      </div>

      {/* Form to set new rules */}
      <form className="container" onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-4 form-group">
            <label htmlFor="subject" className="form-label">
              Subject
            </label>
            <TagInput
              tags={subjectTag}
              setTags={setSubjectTag}
              placeholder="Enter subject tag..."
            />
          </div>

          <div className="col-md-4 form-group">
            <label className="form-label">Emails</label>
            <TagInput
              tags={emailTags}
              setTags={setEmailTags}
              validationRegex={
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
              }
              placeholder="Enter email tag..."
            />
          </div>

          <div className="col-md-4 form-group">
            <label className="form-label">Body</label>
            <TagInput
              tags={bodyTags}
              setTags={setBodyTags}
              placeholder="Enter body tag..."
            />
          </div>
        </div>

        <div className="mb-3">
          <button type="submit" className="btn btn-warning btn-sm">
            Set Rule
          </button>
        </div>
      </form>

      {/* Display Merged Rules */}
      <div className="row mt-4">
        <div className="col">
          <p className="h3">Existing Email Rules</p>
          {filterDataLoading ? (
            <p>Loading data...</p>
          ) : filterDataError ? (
            <p className="text-danger">Failed to load data.</p>
          ) : (
            <div className="border p-3 rounded bg-light">
              <h5 className="mb-2">Merged Email Rules</h5>
              
              <div className="mb-3">
                <strong>Emails:</strong>
                <div className="mt-2">
                  {mergedData?.emails?.length > 0 ? (
                    mergedData?.emails.map((email, index) => (
                      <span key={index} className="badge bg-primary me-2 mb-2">
                        {email}
                      </span>
                    ))
                  ) : (
                    <span className="text-muted">No emails available</span>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <strong>Subjects:</strong>
                <div className="mt-2">
                  {mergedData?.subject?.length > 0 ? (
                    mergedData?.subject.map((subject, index) => (
                      <span key={index} className="badge bg-success me-2 mb-2">
                        {subject}
                      </span>
                    ))
                  ) : (
                    <span className="text-muted">No subjects available</span>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <strong>Bodies:</strong>
                <div className="mt-2">
                  {mergedData?.body?.length > 0 ? (
                    mergedData?.body.map((body, index) => (
                      <span key={index} className="badge bg-danger me-2 mb-2">
                        {body}
                      </span>
                    ))
                  ) : (
                    <span className="text-muted">No bodies available</span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailRules;
